(ns arthur.clock.transport
  "What the clock needs of a thing that plays sound, and nothing more.

  `arthur.clock` does the arithmetic — the frame derivation, the clamping, the
  exposure grid — and a backend only has to answer where the sound has got to
  and do as it is told. Keeping the protocol this thin is what makes the two
  implementations comparable: if the graph backend and the element backend
  disagree about a take's sync, the difference is in these nine methods and not
  in anything derived from them.

  POSITION IS WHERE THE SPEAKER IS, not where the renderer is. A backend that
  schedules audio ahead of the output owes the difference back here — see
  `arthur.clock.graph` — because the picture is drawn against this number and a
  lip-sync tool that draws against the scheduler leads the sound it is matching.")

(defprotocol Transport
  (-position [this]
    "Seconds into the audio, as heard. Never negative, never past `-duration`,
    and wrapped rather than clamped while looping.")
  (-duration [this]
    "Seconds of audio, or nil when the backend has not been told yet.")
  (-playing? [this]
    "Running AND not finished. A backend that has reached its end reports false
    even if nothing told it to stop, because the end of the sound is the
    authority on playback having stopped — see `ui/player`'s loop.")
  (-rate [this])
  (-set-rate! [this r])
  (-play! [this])
  (-pause! [this])
  (-seek! [this seconds]
    "Put the audio at `seconds`. Reading `-position` back must give the same
    number, which is what makes a scrub idempotent.")
  (-set-loop! [this on?])
  (-set-muted! [this on?])
  (-release! [this]
    "Give up whatever this backend holds, because something else is about to be
    the clock. NOT a pause: a backend that owns nothing has nothing to do here,
    and the position it was last at is no longer anybody's business."))
